module.exports = __webpack_public_path__ + "static/media/bg.a568162c.svg";